export var singleQuote = function (x) { return '\'' + x.replace(/'/g, '\\\'') + '\''; };
export var doubleQuote = function (x) { return '"' + x.replace(/"/g, '\\"') + '"'; };
export var repeat = function (n, s) {
    var r = '';
    for (var i = 0; i < n; i++) {
        r += s;
    }
    return r;
};
//# sourceMappingURL=StringUtil.js.map